import {
  AVG_ACCOUNT_LIFESPAN,
  AVG_COMPANY_LIFESPAN,
  CUSTOMERS_RETENTION_RATE,
  MEDIAN_TIME_TO_RETURN,
  REALIZED_CLV,
  WIN_BACK_RATE,
} from "./exampleData";
import { CHART_POSITIVE, MUTED } from "./chartTheme";
import MetricBarChart from "./MetricBarChart";
import AmountBarChart from "./AmountBarChart";

const pct = (v: number) => `${v}%`;
const mo = (v: number) => `${v} mo`;

export const CustomersRetentionRateChart = () => (
  <MetricBarChart
    caption="Monthly retention holds in the low-to-mid 90s — the mirror of churn. It looks high, but even 94% a month compounds to losing roughly half your customers over a year."
    data={CUSTOMERS_RETENTION_RATE}
    seriesName="Retention rate"
    format={pct}
    color={MUTED}
    domain={[0, 100]}
    ticks={[0, 25, 50, 75, 100]}
    reference={{ y: 100 }}
  />
);

export const RealizedClvChart = () => (
  <AmountBarChart
    caption="Realized cLTV is the revenue actually collected from a customer as tenure grows — climbing to $3,800 by month six. Unlike projected cLTV, it only counts money in the door."
    data={REALIZED_CLV}
    seriesName="Realized cLTV"
  />
);

export const AverageAccountLifespanChart = () => (
  <MetricBarChart
    caption="The average paying account stays about 15–17 months — roughly one divided by the monthly churn rate. As churn falls, expected lifespan stretches out."
    data={AVG_ACCOUNT_LIFESPAN}
    seriesName="Avg lifespan"
    format={mo}
    domain={[0, "dataMax + 4"]}
  />
);

export const AverageCompanyLifespanChart = () => (
  <MetricBarChart
    caption="Companies stick around longer than individual accounts — about 18–21 months here. Multi-user accounts are stickier, so their expected lifespan runs ahead of the account average."
    data={AVG_COMPANY_LIFESPAN}
    seriesName="Avg lifespan"
    format={mo}
    domain={[0, "dataMax + 4"]}
  />
);

export const WinBackRateChart = () => (
  <MetricBarChart
    caption="Win-back rate climbs from 18% to 26% — the share of churned logos that resurrect within a year. A healthy signal, but never a substitute for keeping them in the first place."
    data={WIN_BACK_RATE}
    seriesName="Win-back rate"
    format={pct}
    domain={[0, "dataMax + 10"]}
  />
);

export const MedianTimeToReturnChart = () => (
  <MetricBarChart
    caption="The median returner comes back within 3–5 months of churning. A short, stable time-to-return means your win-back motion catches customers before they resettle elsewhere."
    data={MEDIAN_TIME_TO_RETURN}
    seriesName="Median time to return"
    format={mo}
    color={MUTED}
    domain={[0, "dataMax + 3"]}
  />
);
